"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _ImmutableMerchandiseIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableMerchandiseIdMap"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var Hubs = _interopRequireWildcard(require("self-service-api/constants/Hubs"));

var _reactRouterDom = require("react-router-dom");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _Breakpoints = require("pricing-pages-unified-ui/constants/Breakpoints");

var _ProductsAndPlansNavIds = require("pricing-pages-unified-ui/constants/ProductsAndPlansNavIds");

var _urls = require("pricing-pages-unified-ui/utils/urls");

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

var _FeatureTile = _interopRequireDefault(require("./FeatureTile"));

var _Features = _interopRequireDefault(require("self-service-api/constants/Features"));

var AdvancedCrmCta = _styledComponents.default.div.withConfig({
  displayName: "FeaturesSection__AdvancedCrmCta",
  componentId: "bru6k-0"
})(["background-color:", ";border-radius:3px;max-width:816px;text-align:center;padding:25px;margin:16px 0;display:flex;justify-content:center;"], _colors.GYPSUM);

var FeatureRow = _styledComponents.default.div.withConfig({
  displayName: "FeaturesSection__FeatureRow",
  componentId: "bru6k-1"
})(["display:flex;justify-content:center;@media (max-width:", "px){flex-direction:column;}"], _Breakpoints.FEATURES_SECTION - 1);

var FeaturesSectionContainer = _styledComponents.default.div.withConfig({
  displayName: "FeaturesSection__FeaturesSectionContainer",
  componentId: "bru6k-2"
})(["width:100%;max-width:840px;padding:0 20px;z-index:2;"]);

function FeaturesSection(_ref) {
  var onViewMore = _ref.onViewMore,
      history = _ref.history;

  // Removing the free feature here since it's a little redundant
  // on the free tools page that has a free CRM card
  var removeFreeFeature = function removeFreeFeature(features) {
    features = Object.assign({}, features);
    delete features[_Features.default.ALL_CRM_FEATURES];
    return features;
  };

  return _react.default.createElement(FeaturesSectionContainer, null, _react.default.createElement(FeatureRow, null, _react.default.createElement(_FeatureTile.default, {
    modalViewClassName: (0, _publicPageUrls.getGAClassName)('crm-pricing-crmfeatures'),
    header: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.freeCrmTools"
    }),
    hubType: Hubs.HUB_SALES,
    features: _ImmutableMerchandiseIdMap.default[_MerchandiseIds.PRODUCT_CRM].features,
    onViewMore: onViewMore,
    merchandiseId: _MerchandiseIds.PRODUCT_CRM
  }), _react.default.createElement(_FeatureTile.default, {
    modalViewClassName: (0, _publicPageUrls.getGAClassName)('crm-pricing-marketingfeatures'),
    header: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.freeMarketingTools"
    }),
    features: removeFreeFeature(_ImmutableMerchandiseIdMap.default[_MerchandiseIds.PRODUCT_MARKETING_FREE].features),
    hubType: Hubs.HUB_MARKETING,
    onViewMore: onViewMore,
    merchandiseId: _MerchandiseIds.PRODUCT_MARKETING_FREE
  })), _react.default.createElement(AdvancedCrmCta, null, _react.default.createElement("div", {
    style: {
      maxWidth: '550px'
    }
  }, _react.default.createElement("div", null, _react.default.createElement("b", null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.crm.interested"
  }))), _react.default.createElement(_FormattedJSXMessage.default, {
    options: {
      onClick: function onClick() {
        history.push((0, _urls.getProductTabUrl)(_ProductsAndPlansNavIds.SALES));
        window.scrollTo(0, 0);
      },
      gaClassName: (0, _publicPageUrls.getGAClassName)('crm-pricing-salesplans')
    },
    elements: {
      UILink: _UILink.default
    },
    message: "pricingPage.pages.crm.learn_jsx"
  }))), _react.default.createElement(FeatureRow, null, _react.default.createElement(_FeatureTile.default, {
    modalViewClassName: (0, _publicPageUrls.getGAClassName)('crm-pricing-salesfeatures'),
    header: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.freeSalesTools"
    }),
    features: removeFreeFeature(_ImmutableMerchandiseIdMap.default[_MerchandiseIds.PRODUCT_SALES_FREE].features),
    hubType: Hubs.HUB_SALES,
    onViewMore: onViewMore,
    merchandiseId: _MerchandiseIds.PRODUCT_SALES_FREE
  }), _react.default.createElement(_FeatureTile.default, {
    modalViewClassName: (0, _publicPageUrls.getGAClassName)('crm-pricing-servicefeatures'),
    header: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.freeServiceTools"
    }),
    features: removeFreeFeature(_ImmutableMerchandiseIdMap.default[_MerchandiseIds.PRODUCT_SERVICE_FREE].features),
    hubType: Hubs.HUB_SERVICE,
    onViewMore: onViewMore,
    merchandiseId: _MerchandiseIds.PRODUCT_SERVICE_FREE
  })));
}

var _default = (0, _reactRouterDom.withRouter)(FeaturesSection);

exports.default = _default;
module.exports = exports.default;